module.exports = __webpack_public_path__ + "7aa50911da5bffc413d9596bc81cb7e8.svg";